import React, { FC, Fragment } from "react";
import { PurchaseInfoListWithComponentRow } from "../PurchaseInfoList";
import { nanoid } from "nanoid";
import { Divider } from "antd";
import { UI_ModuleInfo } from "../../../../../../UI_ITO/indexUI";

interface PurchaseInfo {
  name: string;
  value: string;
  type: {
    link: string;
    color: string;
  };
}

interface PurchaseInfoProps {
  info: PurchaseInfoListWithComponentRow<PurchaseInfo>;
}

// фрагменты информации о закупке
export const PurchaseInfo: FC<PurchaseInfoProps> = ({ info }) => {
  const renderDividerOrEmptyDiv = (title: string) => {
    if (title !== "start_end_bg") {
      return <Divider />;
    } else {
      return <div style={{ paddingBottom: "24px" }}></div>;
    }
  };

  return (
    <>
      {Object.keys(info)?.map((item) => {
        const id = nanoid();
        const itemKey =
          item as keyof PurchaseInfoListWithComponentRow<PurchaseInfo>;
        const title = itemKey;
        const renderText = {
          purchase: "Закупка",
          client: "Клиент",
          customer: "Заказчик",
          start_end_bg: "Начало и окончание БГ",
        };
        return (
          <Fragment key={id}>
            <UI_ModuleInfo
              style={{ width: "100%", height: "fit-content", margin: 0 }}
              data={info[itemKey]}
              title={renderText[title as keyof typeof renderText]}
            />
            {renderDividerOrEmptyDiv(title)}
          </Fragment>
        );
      })}
    </>
  );
};
